import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslocoService} from '@jsverse/transloco';
import {WeekDay} from '@domain/common/common';

@Pipe({
  name: 'weekday',
  pure: true
})
export class WeekdayPipe implements PipeTransform {

  private readonly transloco = inject(TranslocoService);

  private readonly dayOrder = [
    WeekDay.SU,
    WeekDay.MO,
    WeekDay.TU,
    WeekDay.WE,
    WeekDay.TH,
    WeekDay.FR,
    WeekDay.SA
  ];

  public transform(dayNum: number | null | undefined, abbrev = true): string | null {
    if (dayNum === null || dayNum === undefined || dayNum < 0 || dayNum > 6) {
      return null;
    }
    const day = this.dayOrder[dayNum];
    const prefix = `enum.WeekDay.${abbrev ? 'abbrev' : 'full'}.`;
    return this.transloco.translate(`${prefix}${day}`);
  }

}
